module.exports = __webpack_public_path__ + "img/close.0f3f1041.svg";